export default {
  FETCH_INVITATION_VACANCY_REQUESTED: (state) =>
    (state.isFetchingVacancy = true),

  FETCH_INVITATION_VACANCY_SUCCESS_REQUESTED: (state, data) => {
    state.isFetchingVacancy = false;
    state.data = data;
  },

  FETCH_INVITATION_VACANCY_FAILURE_REQUESTED: (state, message) => {
    state.isFetchingVacancy = false;
    state.message = message;
  },

  INVITE_ACCEPTED_REQUEST: (state) => (state.isInviteRequest = true),

  INVITE_ACCEPTED_SUCCESS_REQUEST: (state, data) => {
    state.isInviteRequest = false;
    state.data.status = "accepted";
  },

  INVITE_ACCEPTED_FAILURE_REQUEST: (state, message) => {
    state.isInviteRequest = false;
  },

  INVITE_REFUSED_REQUEST: (state) => (state.isInviteRequest = true),

  INVITE_REFUSED_SUCCESS_REQUEST: (state, data) => {
    state.isInviteRequest = false;
    state.data.status = "refused";
  },

  INVITE_REFUSED_FAILURE_REQUEST: (state, message) => {
    state.isInviteRequest = false;
  },
};
